import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Calendar, MapPin, Trophy, Ticket, Flame } from "lucide-react";
import { formatDate } from "./NewsPage";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const Poster = ({ t }) => (
  <Link to={`/torneos/${t.id}`} className="group relative rounded-2xl overflow-hidden border border-purple-500/20 hover:border-yellow-400/60 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_25px_60px_rgba(250,204,21,0.15)] bg-[#0a0512]" data-testid={`torneo-card-${t.id}`}>
    <div className="aspect-[3/4] overflow-hidden">
      {t.image ? <img src={t.image} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full bg-gradient-to-br from-purple-900 to-black flex items-center justify-center"><Trophy size={48} className="text-yellow-400/50" /></div>}
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-90" />
    <div className="absolute top-3 left-3 flex gap-2">
      <span className={`px-2 py-0.5 rounded text-[11px] font-bold ${t.status === "proximo" ? "bg-emerald-400 text-black shadow-[0_0_14px_rgba(52,211,153,0.6)]" : "bg-gray-700/80 text-gray-200"}`}>{t.status === "proximo" ? "PRÓXIMO" : "FINALIZADO"}</span>
      {t.format && <span className="px-2 py-0.5 rounded text-[11px] font-bold bg-purple-600/80 text-white">{t.format}</span>}
    </div>
    <div className="absolute inset-x-0 bottom-0 p-4">
      <h3 className="font-black text-white text-base leading-tight mb-1.5 group-hover:text-yellow-300 transition-colors" style={{ fontFamily: "Cinzel, serif" }}>{t.name}</h3>
      <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-gray-300">
        <span className="flex items-center gap-1"><Calendar size={11} className="text-pink-400" /> {formatDate(t.date)}</span>
        {t.entry_fee && <span className="flex items-center gap-1"><Ticket size={11} className="text-yellow-400" /> {t.entry_fee}</span>}
      </div>
      {t.location && <p className="flex items-center gap-1 text-[11px] text-gray-400 mt-1 truncate"><MapPin size={11} /> {t.location}</p>}
    </div>
  </Link>
);

export default function TorneosPage() {
  const [data, setData] = useState({ proximos: [], finalizados: [] });
  const [tab, setTab] = useState("proximos");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/torneos`).then((r) => {
      setData(r.data);
      if (!r.data.proximos?.length) setTab("finalizados");
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const list = data[tab] || [];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16" data-testid="torneos-page">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-8">
          <p className="text-xs tracking-[0.3em] text-yellow-400 font-bold mb-3 flex items-center gap-2"><Flame size={14} /> YU-GI-OH! · CIRCUITO NIRVANA</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-none mb-3">
            <span className="bg-gradient-to-r from-red-500 via-pink-500 to-yellow-400 bg-clip-text text-transparent">Torneos</span>
          </h1>
          <p className="text-gray-400 text-base md:text-lg">Toca un flyer para ver toda la información del evento: fecha, tienda, formato, inscripción y premios.</p>
        </div>

        <div className="flex gap-2 mb-8" data-testid="torneos-tabs">
          {[["proximos", `Próximos (${data.proximos?.length || 0})`], ["finalizados", `Finalizados (${data.finalizados?.length || 0})`]].map(([id, label]) => (
            <button key={id} onClick={() => setTab(id)} className={`px-4 py-2 rounded-full text-sm font-bold transition ${tab === id ? "bg-gradient-to-r from-pink-500 to-orange-500 text-white shadow-lg shadow-pink-500/30" : "bg-purple-900/40 text-gray-300 hover:bg-purple-800/60"}`} data-testid={`torneos-tab-${id}`}>{label}</button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">{[1, 2, 3, 4].map((i) => <div key={i} className="aspect-[3/4] rounded-2xl bg-purple-900/20 animate-pulse" />)}</div>
        ) : list.length === 0 ? (
          <div className="text-center py-20 glass-card rounded-2xl" data-testid="torneos-empty"><Trophy size={40} className="mx-auto text-gray-600 mb-3" /><p className="text-gray-400">{tab === "proximos" ? "Pronto anunciaremos nuevos torneos. ¡Mantente atento!" : "Aún no hay torneos finalizados"}</p></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="torneos-grid">{list.map((t) => <Poster key={t.id} t={t} />)}</div>
        )}
      </div>
    </div>
  );
}
